import {Outlet, Routes, Route, Navigate, useLocation} from "react-router-dom";
import { JSX } from "react/jsx-runtime";

import { NavigationBar } from "./NavigationBar.tsx";
import NoPage from "./pages/NoPage.tsx";
import SignIn from "./pages/SignIn.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import SurveyPage from "./pages/SurveyPage.tsx";

import './css/App.css';

const AppContent : React.FC = () =>
{
  function ProtectedPoute({children} : {children: JSX.Element})
  {
    const user = sessionStorage.getItem("company");
    return user ? children : <Navigate to="/SignIn" />;
  }

  const location = useLocation();

  const hideNavbar = location.pathname.startsWith("/survey/");

  return (
    <>
      {!hideNavbar && <NavigationBar />}
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route index element={<SignIn />} />
          <Route path="SignIn" element={<SignIn />} />
          <Route path="dashboard" element={<ProtectedPoute><Dashboard /></ProtectedPoute>} />
          <Route path="/survey/:id" element={<SurveyPage />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default AppContent;